import { Permission } from '~/types/Permission';

import { checkIsAutomationAdmin } from './checkIsAutomationAdmin';
import { checkIsInternalSuperAdmin } from './checkIsInternalSuperAdmin';
import { and } from './utils/and';
import { or } from './utils/or';

export const canUseAutomation: Permission = and([
  or([checkIsInternalSuperAdmin, checkIsAutomationAdmin]),
]);
